"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Icon_1 = require("../Icon");
var ToolTip_1 = require("./ToolTip");
var clsx_1 = __importDefault(require("clsx"));
var BUTTON_ITEM = "relative text-lochivar-default border border-lochivar-default text-xs lg:text-sm px-1 lg:px-2 my-auto h-8 xl:h-10 first:rounded-l-lg first:border-r-0 last:rounded-r-lg last:border-l-0";
var BASE_ITEM = "outline-none active:outline-none border-0 my-auto h-8 w-8 lg:w-10 lg:h-10 rounded-full relative transition ease-out duration-200 flex-shrink-0";
var DISABLED_ITEM = "opacity-50 cursor-not-allowed pointer-events-none";
var NEGATIVE_INDICATED_ITEM = BASE_ITEM + " bg-gray-200 hover:bg-gray-300";
var PRIMARY_INDICATED_ITEM = BASE_ITEM + " bg-burgundy-default hover:bg-burgundy-dark";
var SECONDARY_INDICATED_ITEM = BASE_ITEM + " bg-lochivar-default/0 hover:bg-lochivar-dark/50";
var styleForItem = function (_a) {
    var indicated = _a.indicated, disabled = _a.disabled, indicatorMode = _a.indicatorMode, appearance = _a.appearance;
    if (appearance === "button") {
        return BUTTON_ITEM;
    }
    var baseClass = BASE_ITEM;
    if (indicated) {
        switch (indicatorMode) {
            case "primary":
                baseClass = PRIMARY_INDICATED_ITEM;
                break;
            case "secondary":
                baseClass = SECONDARY_INDICATED_ITEM;
                break;
            default:
                baseClass = NEGATIVE_INDICATED_ITEM;
                break;
        }
    }
    return (0, clsx_1.default)(baseClass, disabled && DISABLED_ITEM);
};
var BarItem = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, label = _a.label, toolTip = _a.toolTip, toolTipDirection = _a.toolTipDirection, toolTipAlignment = _a.toolTipAlignment, shortCut = _a.shortCut, _b = _a.mode, mode = _b === void 0 ? "primary" : _b, indicated = _a.indicated, _c = _a.indicatorMode, indicatorMode = _c === void 0 ? "negative" : _c, _d = _a.appearance, appearance = _d === void 0 ? "icon" : _d;
    var _e = (0, react_1.useState)(false), hover = _e[0], setHover = _e[1];
    var handleClick = function (e) {
        e.preventDefault();
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    var isButton = appearance === "button";
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ onClick: handleClick, style: isButton ? {} : { outlineColor: "rgba(0,0,0,0)" }, onMouseOver: function () { return setHover(true); }, onMouseOut: function () { return setHover(false); }, className: (0, clsx_1.default)(!disabled && "cursor-pointer", styleForItem({ indicated: indicated, disabled: disabled, indicatorMode: indicatorMode, appearance: appearance }), className) }, { children: [icon ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)("flex m-auto", appearance === "button"
                    ? "text-md px-1"
                    : "text-md lg:text-md xl:text-xl") }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, mode: mode }, void 0) }), void 0)) : label ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: "m-auto" }, { children: label }), void 0)) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex m-auto" }, { children: children }), void 0)), toolTip ? ((0, jsx_runtime_1.jsx)(ToolTip_1.ToolTip, { label: toolTip, direction: toolTipDirection, align: toolTipAlignment, active: hover, shortCut: shortCut }, void 0)) : null] }), void 0));
};
exports.BarItem = BarItem;
